import nls from '../../../../nls/pt-BR.json';
import { useEffect, useState } from 'react';
import { useTypedSelector } from '../../../../../../../hooks/useTypedSelector';
import { useDispatch } from 'react-redux';
import {
  setCanAdvance,
  setExpandedAreaPolygon,
  studiesSelector,
} from '../../../../redux/studies.reducer';
import {
  removeClusters,
  removeMarkers,
  setDisplayCharts,
  setIsActive,
  setIsActiveRightSidebar,
} from '../../../../../redux/dashboardActions';
import { Checkbox } from '../../../../../../../component';
import { PolygonType } from '../../../../redux/studies.model';
import { Map } from 'eemovel-map-library';
import { EXPANDED_AREA_RADIUS } from '../../../../redux/studies.constants';

const getBounds = (polygon: google.maps.Polygon) => {
  const bounds = new google.maps.LatLngBounds();
  polygon.getPath().forEach(function (element, index) {
    bounds.extend(element);
  });
  return bounds;
};

const getPolygonCenter = (polygon: PolygonType) => {
  if (!polygon) return;
  if (polygon instanceof google.maps.Circle) {
    return polygon.getCenter();
  }
  const bounds = getBounds(polygon);
  const center = bounds.getCenter();
  return center;
};

export const QualifyTargetAudience: React.FC = () => {
  const { displayCharts } = useTypedSelector((state) => state.dashboardState);
  const { polygon } = useTypedSelector(studiesSelector);
  const [hasExpandedArea, setHasExpandedArea] = useState<boolean>(true);
  const [expandedArea, setExpandedArea] = useState<google.maps.Circle>();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch([
      setIsActive({ name: 'menuAction', value: '4' }),
      setIsActiveRightSidebar({ name: 'menuAction', value: '2' }),
      setDisplayCharts(null),
      removeMarkers(),
      removeClusters(),
    ]);
  }, []);
  useEffect(() => {
    if (displayCharts === 'socioeconomicDemographic') {
      dispatch(setCanAdvance(true));
    }
  }, [displayCharts]);

  useEffect(() => {
    if (polygon) {
      const center = getPolygonCenter(polygon);
      const newArea = new google.maps.Circle({
        center,
        radius: EXPANDED_AREA_RADIUS,
        map: Map.map,
      });
      setExpandedArea(newArea);
    }
    return () => expandedArea?.setMap(null);
  }, []);
  const handleToggle = () => {
    // User has toggled Expanded Area
    if (hasExpandedArea && polygon && expandedArea) {
      Map.markerCircle?.setMap(null);
      Map.markerCircle = expandedArea;
      expandedArea.setMap(Map.map);
      Map.PoligonOnMap?.setMap(null);
      Map.circleRadius = EXPANDED_AREA_RADIUS;
      dispatch(setExpandedAreaPolygon(expandedArea));
    }
    // User has not toggled expanded Area, and polygon is of type Polygon
    if (!hasExpandedArea && polygon instanceof google.maps.Polygon) {
      Map.PoligonOnMap = polygon;
      polygon.setMap(Map.map);
      Map.markerCircle?.setMap(null);
      dispatch(setExpandedAreaPolygon(null));
    }
    // User has not toggled expanded Area, and polygon is of type Circle
    if (!hasExpandedArea && polygon instanceof google.maps.Circle) {
      Map.markerCircle.setMap(null);
      Map.markerCircle = polygon;
      Map.circleRadius = EXPANDED_AREA_RADIUS;
      polygon.setMap(Map.map);
      dispatch(setExpandedAreaPolygon(null));
    }
  };
  useEffect(() => {
    handleToggle();
  }, [hasExpandedArea, polygon, expandedArea]);
  return (
    <>
      <p className="helper-text">{nls.studyCreationGuide.steps.step5.helper}</p>
      <Checkbox
        cy="ExpandedArea"
        checked={hasExpandedArea}
        action={() => setHasExpandedArea(!hasExpandedArea)}
        name="expandedArea"
        disabled={displayCharts === 'socioeconomicDemographic'}
        label={
          <span style={{ fontSize: 12, fontFamily: 'Open Sans, sans-serif' }}>
            {nls.studyCreationGuide.steps.step5.form.expandedArea}
          </span>
        }
      />
    </>
  );
};
